module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Desktop.58e30f20.png";